import { useState, useEffect } from 'react';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handler = (e: Event) => { e.preventDefault(); setDeferredPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-bb-surface border border-bb-border rounded-lg p-3 flex items-center gap-3 z-50 shadow-lg">
      <span className="text-sm text-bb-text">Install QuantTradeAI</span>
      <button
        onClick={() => { deferredPrompt.prompt(); setDeferredPrompt(null); }}
        className="px-3 py-1 bg-orange-500 text-white text-sm rounded hover:bg-orange-600"
      >Install</button>
      <button onClick={() => setDeferredPrompt(null)} className="text-bb-muted text-xs">✕</button>
    </div>
  );
}
